import { Icon } from "@chakra-ui/react";
import { IIconProps } from "./icon-component.types";

interface IProps extends IIconProps {
    fillPie?: string;
    fillRest?: string;
}

export const IconPieChart = ({ fillPie = "currentcolor", fillRest = "currentcolor", ...props }: IProps) => (
    <Icon viewBox="0 0 24 24" rounded="50%" borderColor="current" {...props}>
        <PieChartSvg fillPie={fillPie} fillRest={fillRest} />
    </Icon>
);

interface IPieChartSvgProps {
    fillPie?: string;
    fillRest?: string;
}

export const PieChartSvg = ({ fillPie = "currentcolor", fillRest = "currentcolor" }: IPieChartSvgProps) => (
    <g transform="translate(2, 2)">
        <path
            fill={fillRest}
            d="M7.853479,1.66617208 L7.853979,11.490567 C7.853979,11.5816596 7.86642553,11.6723251 7.89097323,11.7600478 C8.03980334,12.2919012 8.59160636,12.6024029 9.12345976,12.4535728 L9.12345976,12.4535728 L18.7924411,9.74725326 C18.8301781,10.0828243 18.8495496,10.4238119 18.8495496,10.7692308 C18.8495496,15.8672438 14.6299342,20 9.42477481,20 C4.21961541,20 0,15.8672438 0,10.7692308 C0,6.19556135 3.39625681,2.39880168 7.853479,1.66617208 Z"
        />
        <path
            fill={fillPie}
            d="M9.42477481,0 L9.42477481,9.45098244 C9.42477481,10.0032672 9.87249006,10.4509824 10.4247748,10.4509824 C10.5158674,10.4509824 10.6065329,10.4385359 10.6942556,10.4139882 L20,7.80993419 L20,7.80993419 C18.6871925,3.30116199 14.4496,0 9.42477481,0 Z"
        />
    </g>
);
